module.exports = __webpack_public_path__ + "img/audiomack.b0db2b39.png";